import { presetKeyParam as presetKey } from '@entity-framework/entity-grid/state/constants';

export const payrollIdParam = 'payrollId';
export const presetKeyParam = presetKey;
